import RecordRTC from 'recordrtc'

let recorder

export const requestMicPermission = () => {
  return new Promise((resolve, reject) => {
    if (!navigator.mediaDevices) {
      alert('Your browser does not seem to support recording')

      return reject('Browser does not support recording')
    }

    navigator.mediaDevices
      .getUserMedia({
        video: false,
        audio: {
          autoGainControl: true
        }
      })
      .then(stream => {
        recorderAPI.build(stream)

        resolve(stream)
      })
      .catch(() => {
        alert('Please allow access to your microphone to continue, thank you!')

        reject()
      })
  })
}

const recorderAPI = {
  build: stream => {
    const config = {
      type: 'audio',
      mimeType: 'audio/wav',
      recorderType: RecordRTC.StereoAudioRecorder
    }

    recorder = RecordRTC(stream, config)

    return recorder
  },

  startRecording: () => {
    if (!recorder) {
      return
    }

    recorder.startRecording()
  },

  pauseRecording: () => {
    if (!recorder) {
      return
    }

    recorder.pauseRecording()
  },

  stopRecording: () => {
    return new Promise((resolve, reject) => {
      if (!recorder) {
        return reject()
      }

      recorder.stopRecording(audioURL => {
        resolve(recorder.getBlob())

        recorder.reset()
      })
    })
  },

  destroy: () => {
    recorder.destroy()
  }
}

export default recorderAPI
